import { Component } from '@angular/core';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-failed-reminder-modal',
  templateUrl: './failed-reminder-modal.component.html',
  styleUrl: './failed-reminder-modal.component.scss',
  standalone: true,
  imports: [KorviuButtonComponent, TranslateModule, NzModalModule]
})
export class FailedReminderModalComponent {
  constructor(private _modal: NzModalRef) {}

  public onCancelClick(): void {
    this._modal.destroy();
  }

  public onTryAgainButtonClick(): void {
    this._modal.destroy();
  }
}
